import { Injector } from '@angular/core';

export let appInjectorResolver: (appRef: Injector) => void;

export const appInjector = new Promise<Injector>((resolver) => {
  appInjectorResolver = resolver;
});
